.template-combobox {
  min-width: 0;
}
